/*
 * Copyright 2026 The Apache Software Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const MAVEN_OWNER = 'apache'

export const MAVEN_REPOS: readonly string[] = [
  'maven-site',
  'maven-sources',
  'maven-build-cache-extension',
  'maven',
  'maven-mvnd',
  'maven-integration-testing',
  'maven-resolver',
  'maven-resolver-ant-tasks',
  'maven-wrapper',
  'maven-clean-plugin',
  'maven-compiler-plugin',
  'maven-deploy-plugin',
  'maven-install-plugin',
  'maven-resources-plugin',
  'maven-site-plugin',
  'maven-surefire',
  'maven-verifier-plugin',
  'maven-ear-plugin',
  'maven-ejb-plugin',
  'maven-jar-plugin',
  'maven-rar-plugin',
  'maven-war-plugin',
  'maven-acr-plugin',
  'maven-shade-plugin',
  'maven-source-plugin',
  'maven-jlink-plugin',
  'maven-jmod-plugin',
  'maven-changelog-plugin',
  'maven-changes-plugin',
  'maven-checkstyle-plugin',
  'maven-doap-plugin',
  'maven-javadoc-plugin',
  'maven-jdeps-plugin',
  'maven-jxr',
  'maven-pmd-plugin',
  'maven-project-info-reports-plugin',
  'maven-antrun-plugin',
  'maven-archetype',
  'maven-artifact-plugin',
  'maven-assembly-plugin',
  'maven-dependency-plugin',
  'maven-enforcer',
  'maven-gpg-plugin',
  'maven-help-plugin',
  'maven-invoker-plugin',
  'maven-jarsigner-plugin',
  'maven-jdeprscan-plugin',
  'maven-plugin-tools',
  'maven-release',
  'maven-remote-resources-plugin',
  'maven-scm',
  'maven-scm-publish-plugin',
  'maven-scripting-plugin',
  'maven-stage-plugin',
  'maven-toolchains-plugin',
  'maven-archiver',
  'maven-artifact-transfer',
  'maven-common-artifact-filters',
  'maven-dependency-analyzer',
  'maven-dependency-tree',
  'maven-file-management',
  'maven-filtering',
  'maven-invoker',
  'maven-jarsigner',
  'maven-mapping',
  'maven-project-utils',
  'maven-reporting-api',
  'maven-reporting-exec',
  'maven-reporting-impl',
  'maven-script-interpreter',
  'maven-shared-incremental',
  'maven-shared-io',
  'maven-shared-jar',
  'maven-shared-resources',
  'maven-shared-utils',
  'maven-verifier',
  'maven-doxia',
  'maven-doxia-site',
  'maven-doxia-sitetools',
  'maven-doxia-book-maven-plugin',
  'maven-doxia-book-renderer',
  'maven-doxia-converter',
  'maven-doxia-linkcheck',
  'maven-archetypes',
  'maven-parent',
  'maven-apache-parent',
  'maven-apache-resources',
  'maven-fluido-skin',
  'maven-dist-tool',
  'maven-gh-actions-shared',
  'maven-jenkins-env',
  'maven-jenkins-lib',
  'maven-indexer',
  'maven-plugin-testing',
  'maven-wagon',
  'maven-studies',
  'maven-repository-tools',
  'maven-doxia-ide',
]
